import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalDataService {

  public selectedMatchSet: any;

  constructor() { }
}
